//Import Styles
import '../styles/faq.css';

//React imports
import React, { useState } from 'react';

//Import components
import Faq from '../components/Faq';
import { NavLink } from 'react-router-dom';

const Technology = () => {
  //Set a state for the FAQs
  const [faqs, setFaqs] = useState([
    {
      question: 'ReactJS Software Components',
      answer: `I have a full background developing using ReactJS.
      I use hooks, conditional - ternary statements, arrays, object, and API 
      databsource access.`,
      id: 1,
    },
    {
      question: 'ReactJS is compiled.',
      answer: `Many employers prefer and directly ask for ReactJS technology programmers. The code is small and executies fast for 
      rapid access website information displays.`,
      id: 2,
    },
    {
      question: 'Any experience with MERN?',
      answer: `Yes, I have developed and have projects using MERN. It is MongoDB, ExpressJS, ReactJS, and NodeJS
      full stack technologies. They are also fast in displaying website pages. `,
      id: 3,
    },
  ]);

  return (
    <div className="faqWrapper">
      <h1 className="faqTitle">Software Development</h1>
      <div className="darkGlassCard faqContainer">
        <div className="space"> </div>
        <div className="space"> </div>
        <div className="scroll-container">
          <div className="scroll-text">My Best ReactJS Websites</div>
        </div>
        <>
          <div className="space"> </div>
          <div className="space"> </div>
          {/* <div className="linkcenter">
            <NavLink to="/React" className={`navMenuItem`}>
              James L. Avakian
            </NavLink>
            <NavLink to="/React2" className={`navMenuItem`}>
              Optical Automation
            </NavLink>
            <NavLink to="/Products" className={`navMenuItem`}>
              Projects
            </NavLink>
            <NavLink to="/Technology" className={`navMenuItem`}>
              Mobile
            </NavLink>
          </div> */}
          <div className="space"> </div>
          <div className="space"> </div>
        </>
        {/* //Map through the FAQs and display them */}
        {faqs.map((faq) => {
          return (
            <Faq key={faq.id} question={faq.question} answer={faq.answer} />
          );
        })}

        <div className="space"> </div>
        <div className="space"> </div>
        <div className="linkcenter">
          <div className="space"> </div>
          <div className="space"> </div>
        </div>
      </div>
    </div>
  );
};

export default Technology;
